import HttpService from "./HttpService";

export default class CapturaService extends HttpService{
  constructor(props) {
    super(props);
  }

  recuperarDadosLinkMeuVivo(codigo,hrefer,origem){
    return  this._post('capturav1/recuperarDadosLinkMeuVivo',{
      codigo,
      hrefer,
      origem
    });
  }

  logarErro(msg,num_cpf,id_link){
    return this._post('capturav1/logarErro',{
      msg,
      num_cpf,
      id_link
    })
  }

  enviarDigitalizacao(dados){
    return this._post('capturav1/digitalizar',dados);
  }

  enviarMotorBio(chave,protocolo,id_link,resultado_base1n = null){
    let d = { chave,protocolo,id_link };
    if (resultado_base1n !== null) {
      d.resultado_base1n = resultado_base1n;
    }
    return this._post('capturav1/enviarDadosMotorBio',d);
  }

}



// WEBPACK FOOTER //
// ./src/services/CapturaService.js